/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon24Regular = forwardRef('ArrowDim2DiagMaxRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.5 2.25a.75.75 0 0 0 0 1.5h4.69l-6.22 6.22a.75.75 0 1 0 1.06 1.06l6.22-6.22V9.5a.75.75 0 0 0 1.5 0V4.25a2 2 0 0 0-2-2H14.5Z" }),
        React.createElement("path", { d: "M11.03 14.03a.75.75 0 1 0-1.06-1.06l-6.22 6.22V14.5a.75.75 0 0 0-1.5 0v5.25a2 2 0 0 0 2 2H9.5a.75.75 0 0 0 0-1.5H4.81l6.22-6.22Z" })));
});
